var _path, _line, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 3,
    stroke: "#000000",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.61,51.62A24.73,24.73,0,1,1,52.94,9.55"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5.47,
    y1: 26.01,
    x2: 46.61,
    y2: 26.01
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.47,
    y1: 38.56,
    x2: 41.65,
    y2: 38.56
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.f7219eb00c4fd56f82015b6b254ef6a4.svg";
export { ForwardRef as ReactComponent };